module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-freight-extra-service"
  }, [_c('div', {
    staticClass: "z-freight-extra-service__container"
  }, [(!_vm.$props.hideCheck) ? _c('z-check', {
    attrs: {
      "label": _vm.$props.label,
      "name": ('freight-extraservice-check-' + _vm.id),
      "id": ('freight-extraservice-check-' + _vm.id),
      "value": true,
      "disabled": _vm.$props.disabled || _vm.$props.disabledCheck,
      "dirty": _vm.dirtyObj.service
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "service", $event)
      }
    },
    model: {
      value: (_vm.val.value),
      callback: function($$v) {
        _vm.$set(_vm.val, "value", $$v)
      },
      expression: "val.value"
    }
  }) : _vm._e(), (_vm.$props.payers) ? _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (!!_vm.val.value && _vm.$props.payerRequire)
      }),
      expression: "{'required': (!!val.value && $props.payerRequire)}"
    }],
    attrs: {
      "label": ("Плательщик<br>(" + (_vm.$props.label) + ")"),
      "name": ('freight-extraservice-payer-' + _vm.id),
      "id": ('freight-extraservice-payer-' + _vm.id),
      "disabled": _vm.$props.disabled || _vm.$props.disabledPayer,
      "inline": true,
      "noMargin": true,
      "dirty": _vm.dirtyObj.payer,
      "data-vv-name": ('freight-extraservice-payer-' + _vm.id),
      "data-vv-as": ' ',
      "error": _vm.errors.first(('freight-extraservice-payer-' + _vm.id))
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "payer", $event)
      }
    },
    model: {
      value: (_vm.val.payer_id),
      callback: function($$v) {
        _vm.$set(_vm.val, "payer_id", $$v)
      },
      expression: "val.payer_id"
    }
  }, _vm._l((_vm.$props.payers), function(payer, i) {
    return _c('option', {
      key: (payer.hid + '-' + i),
      domProps: {
        "value": payer.id
      }
    }, [_vm._v(_vm._s(payer.name))])
  })) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8442d0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZFreightExtraService.vue
// module id = 1206
// module chunks = 0